import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { PrioritiesService } from '../priorities.service';
import { UploadPriorities } from '../priorities.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-edit-cerere-priority',
    templateUrl: './edit-cerere-priority.component.html',
    styleUrls: ['./edit-cerere-priority.component.scss'],
})
export class EditCererePriorityComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    zileOptions: { name: string; id: number }[] = [
        { name: '--Alegeți--', id: -1, },
        { name: 'Zile calendaristice', id: 1 },
        { name: 'Zile lucrătoare', id: 2, }
    ];

    form: FormGroup = new FormGroup({
        name: new FormControl(this.data.name, [Validators.required]),
        color: new FormControl(this.data.color, [Validators.required]),
        time: new FormControl(this.data.time, [Validators.required, Validators.min(1)]),
        type: new FormControl(this.data.type, [Validators.required, notDefaultValidator('-1')]),
        observatii: new FormControl('', []),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditCererePriorityComponent>,
        private requestService: PrioritiesService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, color, time, type, observatii } = this.form.value;
        const payload: UploadPriorities = {
            id: this.data.id,
            name,
            color,
            time,
            type,
            observatii
        };

        this.requestService
            .updateEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
